import { ObjectOfStringValue } from '../hooks/useQuery';

/**
 * 设置页面路由
 */
const defaultRouterAIGC: Array<ObjectOfStringValue> = [
  {
    path: './Analysis',
    component: '@/pages/aigc/pages/DataAnalysis/index',
  },
  {
    path: './Action/GptAnalysis', // GPT分析
    component: '@/pages/datalab/pages/BehaviorAnalysis/GptAnalysis/index',
  },
  {
    path: './AITools',
    component: '@/pages/aigc/pages/Tools/index',
  },
  {
    path: './ResourceUpload',
    component: '@/pages/aigc/pages/ResourceUpload/index',
  },
  {
    path: './report-summary',
    component: '@/pages/aigc/pages/reportSummary/index',
  },
  {
    path: './Text2SQL',
    component: '@/pages/aigc/pages/Text2SQL/index',
  },
  {
    path: './GPTTranslator',
    component: '@/pages/aigc/pages/GPTTranslator/index',
  },
  {
    path: './motion-capture',
    component: '@/pages/aigc/pages/MotionCapture/index',
  },
  // {
  //   path: './agent',
  //   component: '@/pages/aigc/pages/Agent/index',
  // },
];
export default [
  // 下面四个重定向的作用是，点击头部关联左侧导航高亮，也需要点击左侧导航关联其他路径的头部且高亮，其他系统没有这个特性功能。故在外层实现，为不改变公共menu组件，
  {
    path: '/aigc',
    exact: true,
    redirect: '/aigc/AITools',
  },
  {
    path: '/aigc2',
    exact: true,
    redirect: '/aigc/Action/GptAnalysis',
  },
  {
    path: '/aigc/Action/GptAnalysis',
    exact: true,
    redirect: '/aigc2/Action/GptAnalysis',
  },
  {
    path: '/aigc2/AITools',
    exact: true,
    redirect: '/aigc/AITools',
  },
  // home页菜单高亮
  {
    path: '/agent',
    exact: true,
    redirect: '/agent/home',
  },
  // 正常路径在这里添加
  {
    path: '/aigc',
    component: '@/pages/aigc/layouts/index',
    routes: defaultRouterAIGC,
  },
  {
    // 额外新建一个路由来存储
    path: '/aigc2',
    component: '@/pages/aigc/layouts/index',
    routes: defaultRouterAIGC,
  },
  {
    path: '/agent',
    component: '@/pages/aigc/layouts/agentLayout/index', // 使用新布局
    routes: [
      {
        path: './home',
        component: '@/pages/aigc/pages/Agent/Home/index',
      },
      {
        path: './collection',
        component: '@/pages/aigc/pages/Agent/AgentCollection/index',
      },
      {
        path: './skills/:skillId',
        component:
          '@/pages/aigc/pages/Agent/SkillsCollection/SkillDetail/index',
      },
      {
        path: './skills',
        component: '@/pages/aigc/pages/Agent/SkillsCollection/index',
      },
      {
        path: './files',
        component: '@/pages/aigc/pages/Agent/FileLibrary/index',
      },
      {
        path: './chat',
        component: '@/pages/aigc/pages/Agent/ChatPage/index',
      },
      {
        // share chat
        path: './chatShare',
        component: '@/pages/aigc/pages/Agent/ChatShare/index',
      },
      {
        path: './tempPool',
        component: '@/pages/aigc/pages/Agent/ChatShare/index',
      },
      {
        path: './testBiData',
        component: '@/pages/aigc/pages/testBiData/index',
      },
      { component: '@/pages/globalpedia/pages/NotFoundPage' },
    ],
  },
];

export const INDEPENDENT_ROUTERS = [
  {
    path: '/agent/iframe',
    component: '@/pages/aigc/pages/Agent/ChatIWiki/index.tsx',
  },
];
